module.exports = __webpack_public_path__ + "static/knowledge-d4422f1e0abd5813e81a6965dbceafba.jpg";